import Overlay from 'ol/Overlay';

import { getLayerById, map } from './map/tools'
import { locallyAr5 } from './storage'

if (!locallyAr5) {
  const p = document.getElementById('wmsInfoPopup');
  if (p) p.hidden = false;
}

const wmsInfoPopup = new Overlay({
  id: 'wmsInfo',
  element: document.getElementById('wmsInfoPopup') // ol will hide dom element
});

export const getFeatureInfo = (coordinate, pixel) => {
  const u = getLayerById('utenforWMS');
  if (u && u.getVisible()) {
    const rgba = u.getData(pixel);
    if (rgba && rgba.length > 3 && rgba[3] > 0) {
      // const v = map.getView();
      // const url = u.getSource().getFeatureInfoUrl(
      //   coordinate,
      //   v.getResolution(),
      //   v.getProjection().getCode(),
      //   { INFO_FORMAT: 'text/html' }
      // );
      // if (url) {
      //   fetch(url).then(response => response.text()).then(html => {
      //     console.log(html);
      //   });
      // }
      wmsInfoPopup.setPosition(coordinate);
      if (!wmsInfoPopup.getMap()) map.addOverlay(wmsInfoPopup);
    }
  }
};

export const hideWmsInfo = () => {
  // map.getOverlayById('wmsInfo');
  // map.removeOverlay(wmsInfoPopup);
  wmsInfoPopup.setPosition();
};

wmsInfoPopup.getElement().onclick = hideWmsInfo;
wmsInfoPopup.getElement().querySelector('#xWmsInfoPopup').onclick = hideWmsInfo;
